import polygonClipping from "polygon-clipping";
import wellknown from "wellknown";
import proj4 from "proj4";
export const propertyFilter = (type, filterParams) => {
    // TODO: Extend it, that 'or' concatination would be possible. Currently all the properties are concatenated with an 'and' operator.
    const filters = [];
    if (filterParams.properties) {
        filterParams.properties.forEach((prop) => {
            filters.push(`${prop.key} ${prop.operator} ${prop.value}`);
        });
    }
    if (filterParams.stream) {
        filters.push(`stream eq ${filterParams.stream}`);
    }
    if (filterParams.sequence) {
        filters.push(`sequence_uid eq '${filterParams.sequence}'`);
    }
    if (filterParams.framerange) {
        filters.push(`framenumber ge ${filterParams.framerange.minFramenumber} and framenumber lt ${filterParams.framerange.maxFramenumber}`);
    }
    if (filterParams.within) {
        filters.push(encodeURIComponent(`geom within 'SRID=${filterParams.within.epsg};POLYGON((${filterParams.within.minEasting} ${filterParams.within.minNorthing} 0, ${filterParams.within.minEasting} ${filterParams.within.maxNorthing} 0, ${filterParams.within.maxEasting} ${filterParams.within.maxNorthing} 0, ${filterParams.within.maxEasting} ${filterParams.within.minNorthing} 0, ${filterParams.within.minEasting} ${filterParams.within.minNorthing} 0))'`));
    }
    if (filterParams.projectScope?.campaign_uids && filterParams.projectScope.campaign_uids.length > 0) {
        if (type === "frame" || type === "fragment" || type === "routes" || type === "campaigns") {
            filters.push(`campaign_uid in '(${filterParams.projectScope.campaign_uids.join(", ")})'`);
        }
        else if (type === "routeLines" || type === "routeHexes") {
            filters.push(`campaign_uids overlap '(${filterParams.projectScope.campaign_uids.join(", ")})'`);
        }
    }
    if (filterParams.projectScope?.start_timestamp) {
        if (type === "frame") {
            filters.push(`timestamp ge '${filterParams.projectScope.start_timestamp}'`);
        }
        else if (type === "routes" ||
            type === "routeLines" ||
            type === "routeHexes" ||
            type === "fragment" ||
            type === "campaigns") {
            // if projectscope.start_timestamp - projectscope.end_timestamp
            // includes some part of start_timestamp - end_timestamp
            filters.push(`end_timestamp ge '${filterParams.projectScope.start_timestamp}'`);
        }
    }
    if (filterParams.projectScope?.end_timestamp) {
        if (type === "frame") {
            filters.push(`timestamp le '${filterParams.projectScope.end_timestamp}'`);
        }
        else if (type === "routes" ||
            type === "routeLines" ||
            type === "routeHexes" ||
            type === "fragment" ||
            type === "campaigns") {
            // if projectscope.start_timestamp - projectscope.end_timestamp
            // includes some part of start_timestamp - end_timestamp
            filters.push(`start_timestamp le '${filterParams.projectScope.end_timestamp}'`);
        }
    }
    if (filters.length === 0)
        return ""; // No filter needs to be applied
    return `filter=${filters.join(" and ")}`;
};
export const boundaryFilter = (filterParams) => {
    if (!filterParams.boundary && !filterParams.projectScope?.boundaries) {
        // No boundary filter needs to be applied
        return "";
    }
    else if (filterParams.boundary && !filterParams.projectScope?.boundaries) {
        // Only the boundary needs to be applied
        return `SRID=${filterParams.boundary.epsg};POLYGON((${filterParams.boundary.minEasting} ${filterParams.boundary.minNorthing} 0, ${filterParams.boundary.minEasting} ${filterParams.boundary.maxNorthing} 0, ${filterParams.boundary.maxEasting} ${filterParams.boundary.maxNorthing} 0, ${filterParams.boundary.maxEasting} ${filterParams.boundary.minNorthing} 0, ${filterParams.boundary.minEasting} ${filterParams.boundary.minNorthing} 0))`;
    }
    else if (!filterParams.boundary && filterParams.projectScope?.boundaries) {
        // Only the projectscope boundary needs to be applied
        const wkt = wellknown.stringify(filterParams.projectScope.boundaries.geometry);
        return `SRID=4326;${wkt}`;
    }
    else if (filterParams.boundary && filterParams.projectScope?.boundaries) {
        // the two boundaries needs to be intersected and applied
        let intersections;
        if (filterParams.projectScope?.boundaries?.geometry?.coordinates) {
            const transformed_coordinates = _transformPolygon(filterParams.projectScope.boundaries.geometry.coordinates, "EPSG:4326", `EPSG:${filterParams.boundary.epsg}`);
            intersections = polygonClipping.intersection([
                [
                    [filterParams.boundary.minEasting, filterParams.boundary.minNorthing],
                    [filterParams.boundary.minEasting, filterParams.boundary.maxNorthing],
                    [filterParams.boundary.maxEasting, filterParams.boundary.maxNorthing],
                    [filterParams.boundary.maxEasting, filterParams.boundary.minNorthing],
                    [filterParams.boundary.minEasting, filterParams.boundary.minNorthing],
                ],
            ], transformed_coordinates);
        }
        else {
            throw new Error("Invalid geometry of projectscope provided!");
        }
        if (intersections.length === 0) {
            throw new Error("No intersection of boundary");
        }
        // Reduce decimals of intersections to reduce uri length
        intersections = intersections.map((polygon) => polygon.map((ring) => ring.map(([x, y]) => {
            const decimals = filterParams.boundary.epsg === 4326 ? 6 : 0;
            return [parseFloat(x.toFixed(decimals)), parseFloat(y.toFixed(decimals))];
        })));
        // Intersection is a single polygon
        if (intersections.length === 1) {
            const wkt = wellknown.stringify({ type: "Polygon", coordinates: intersections[0] });
            return `SRID=${filterParams.boundary.epsg};${wkt}`;
        }
        // Intersection is a multipolygon
        const wkt = wellknown.stringify({ type: "MultiPolygon", coordinates: intersections });
        return `SRID=${filterParams.boundary.epsg};${wkt}`;
    }
    return "";
};
const _transformPolygon = (coordinates, fromProjection, toProjection) => {
    return coordinates.map((coord) => {
        if (Array.isArray(coord[0])) {
            return _transformPolygon(coord, fromProjection, toProjection);
        }
        return proj4(fromProjection, toProjection, coord);
    });
};
//# sourceMappingURL=projectscope.js.map